
















































































import { defineComponent, reactive, watch } from '@vue/composition-api';
import { Location } from '@/models/entities/Location';
import ImageUpload from '@/components/utils/ImageUpload.vue';

interface Props {
  entityLocations: Location[];
  addNewLocation: (location: Location) => {};
}

interface State {
  newLocation: Location;
}

const Component = defineComponent({
  name: 'LocationsSimpleTable',

  components: { ImageUpload },
  props: {
    entityLocations: Array,
    addNewLocation: Function,
  },

  setup(props: Props) {
    const locations = props.entityLocations;

    const state = reactive({
      newLocation: new Location({}),
    }) as State;

    watch(
      props,
      (newProps: Props) => {
        Object.assign(locations, newProps.entityLocations);
      },
      { immediate: false, deep: true },
    );

    function deleteLocation(location: Location) {
      const indexToDelete = locations.indexOf(location);
      locations.splice(indexToDelete, 1);
    }

    function addLocation() {
      props.addNewLocation(state.newLocation);
      state.newLocation = new Location({});
    }

    return {
      state,
      locations,
      deleteLocation,
      addLocation,
    };
  },
});
export default Component;
